/**
 * Fehlerschlüssel → Satz für Menschen. (07.09.2026, ausgegliedert 21.09.2026)
 *
 * Gemeinsam für Karten (tool-cards.ts) und Schritt-Zeilen (schritte.ts) —
 * eine Übersetzung, zwei Anzeigen.
 */
/**
 * Aus einem Werkzeug-Ergebnis den Satz holen, den ein MENSCH lesen soll.
 * (07.09.2026)
 *
 * Martin, mit Bild einer Karte, auf der nur „titel-ist-transkript" stand:
 * *„Was ist das für eine Fehlermeldung? Was mach ich mit dieser? Das gehört
 * alles viel userfreundlicher gemacht."*
 *
 * Er hat recht. `error` ist ein SCHLÜSSEL für den Code — kurz, stabil,
 * maschinenlesbar. Daneben liefert dasselbe Werkzeug meist schon einen
 * ganzen Satz (`hint`, `hinweis`, `message`), und genau der wurde
 * weggeworfen.
 *
 * ⚠️ Reihenfolge: erst der Satz, dann die Übersetzung des Schlüssels, erst
 *    zuletzt der Schlüssel selbst. Ein Schlüssel auf dem Schirm ist immer
 *    ein Fehler in der Anzeige, nie eine Information.
 */
import { fuerMenschen } from "./karten-text.js";

const FEHLER_WORTE: Record<string, string> = {
  "titel-ist-transkript":
    "Der Titel war noch der ganze gesprochene Text. Vespera formuliert ihn kurz und legt die Aufgabe dann an.",
  "validation-failed": "Der Befehl war so nicht erlaubt.",
  "not-open": "Diese Aufgabe ist nicht mehr offen.",
  "text-missing": "Es fehlte der Text.",
  "text fehlt": "Es fehlte der Text.",
};

export function menschlicherFehler(
  r: Record<string, unknown>,
  ersatz: string,
): string {
  // `satz`: der Satz eines Werkzeugs, der ausdrücklich für Menschen geschrieben ist
  // (die Ketten browser_ablauf/screen_ablauf, Ticket 2830) — vor `hinweis`, der an das Modell geht.
  // 15.10.2026: und von jedem Feld nur die Sätze an Martin (lib/karten-text.ts) —
  // „NICHTS in Blender ausgeführt. Frag den Nutzer …“ stand sonst als Fehlertext da.
  for (const feld of ["satz", "hint", "hinweis", "message", "meldung"] as const) {
    const wert = r[feld];
    if (typeof wert !== "string" || wert.trim().length <= 3) continue;
    const satz = fuerMenschen(wert);
    if (satz.length > 3) return satz;
  }
  const code = typeof r.error === "string" ? r.error.trim() : "";
  if (code && FEHLER_WORTE[code]) return FEHLER_WORTE[code];
  /*
   * Ein Schlüssel sieht so aus: klein, mit Bindestrichen, ohne Leerzeichen.
   * So etwas ist nie ein Satz — dann lieber der allgemeine Ersatz.
   */
  if (code && /^[a-z0-9]+(?:[-_][a-z0-9]+)+$/.test(code)) return ersatz;
  return fuerMenschen(code, ersatz);
}
